import React from "react";
import { Spinner } from "../../Ui/index.jsx";

// What the page area shows while a page's code or the lists it needs are on their way.
export function RouteLoading() {
  return <div className="Atg-Route-Loading"><Spinner label="Loading the page" /></div>;
}
